import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const removeTag = async ({
  orgId,
  tagId,
}: {
  orgId: string;
  tagId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(`${orgId}/tags/${tagId}`);
  return response.data;
};

export function useRemoveTag(
  queryOptions?: UseMutationOptions<
    void,
    HttpError,
    { orgId: string; tagId: string }
  >,
) {
  return useMutation({
    mutationFn: ({ orgId, tagId }) => removeTag({ orgId, tagId }),
    ...queryOptions,
  });
}
